var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 0C5.2395 0 0 4.95218 0 11.6404C0 15.139 1.43422 18.162 3.76906 20.2506C3.96464 20.4268 4.08295 20.6707 4.09261 20.9339L4.1578 23.0683C4.17953 23.7492 4.88215 24.1911 5.5051 23.9182L7.88581 22.8679C8.08863 22.7786 8.31318 22.7617 8.52566 22.8196C9.61944 23.1214 10.7857 23.2808 12.0002 23.2808C18.7608 23.2808 24.0003 18.3286 24.0003 11.6404C24.0003 4.95218 18.7608 0 12.0002 0Z",
    fill: "url(#paint0_linear_165_2614)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79515 15.0448L8.32034 9.4528C8.88051 8.56425 10.0829 8.34212 10.9232 8.97231L13.7264 11.0754C13.9848 11.2685 14.3373 11.2661 14.5933 11.0729L18.3792 8.19966C18.8839 7.81575 19.5454 8.4218 19.205 8.95782L15.6822 14.5474C15.122 15.436 13.9196 15.6581 13.0794 15.0279L10.2761 12.9249C10.0177 12.7317 9.66523 12.7341 9.40929 12.9273L5.62091 15.803C5.11628 16.1869 4.4547 15.5808 4.79515 15.0448Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_2614",
    x1: -0.000150923,
    y1: 0,
    x2: -0.000150923,
    y2: 24.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/facebookMessenger.73df9a7651162cc37bbc2a41287456aa.svg";
export { ForwardRef as ReactComponent };